module.exports = __webpack_public_path__ + "static/media/3_PE_Constant Mo (Vice President)-min.2dd907a9.jpg";